import React from "react";
import ReactDOM from "react-dom/client";
import App from "@src/App.jsx";
import { Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Theme accentColor="indigo" grayColor="slate" scaling="110%">
      <App />
    </Theme>
  </React.StrictMode>,
);
